import $ from '@rover/globals/jquery';

function getWords(s) {
  const trimmedString = s.replace(/(^\s*)|(\s*$)/gi, '');
  if (trimmedString === '') return [];
  return trimmedString.split(/\s+/);
}

function getWordCount(s) {
  return getWords(s).length;
}

$.fn.wordCount = function wordCount() {
  return getWordCount($(this).val());
};

function updateWordCount(e) {
  const $el = $(e.currentTarget);
  let wordCount = getWordCount($el.val());
  const minWords = $el.attr('data-min-words');
  if (minWords) wordCount = minWords - wordCount;
  $el
    .siblings()
    .find('.js-word-count-input-counter')
    .html(Math.max(0, wordCount));
}

function updateCharCount(evt) {
  const $target = $(evt.target);
  $target
    .siblings()
    .find('.js-char-count-input-counter')
    .html($target.val().length);
}

function initWordCount() {
  $('.js-word-count-input').trigger('input');
}

function initCharCount() {
  $('.js-char-count-input').trigger('input');
}

function init() {
  $('.js-word-count-input').on('input', updateWordCount);
  $('.js-char-count-input').on('input', updateCharCount);

  initWordCount();
  initCharCount();
}

export default {
  init,
  getWords,
  getWordCount,
  updateWordCount,
  updateCharCount,
  initWordCount,
  initCharCount,
};



// WEBPACK FOOTER //
// ../utilities/text-utilities.js